<template>
  <div id="base_image" >
    <img src="../../assets/communication_path.png">
    <input
      v-model="selected.sender"
      value="grp1.ref1.oc"
      aria-label
      type="radio"
      id="check3"
    >
    <input
      v-model="selected.sender"
      value="grp1.ref1.ic1"
      aria-label
      type="radio"
      id="check7"
    >
    <input
      v-model="selected.sender"
      value="grp1.ref1.icn"
      aria-label
      type="radio"
      id="check8"
    >
    <input
      v-model="selected.sender"
      value="grp1.ref1.oc_ad1"
      aria-label
      type="radio"
      id="check1"
    >
    <input
      v-model="selected.sender"
      value="grp1.ref1.oc_adn"
      aria-label
      type="radio"
      id="check2"
    >
    <input
      v-model="selected.sender"
      value="grp1.ref1.ic1_ad1"
      aria-label
      type="radio"
      id="check6"
    >
    <input
      v-model="selected.sender"
      value="grp1.ref1.ic1_adn"
      aria-label
      type="radio"
      id="check4"
    >
    <input
      v-model="selected.sender"
      value="grp1.ref1.icn_ad1"
      aria-label
      type="radio"
      id="check9"
    >
    <input
      v-model="selected.sender"
      value="grp1.ref1.icn_adn"
      aria-label
      type="radio"
      id="check5"
    >
    <input
      v-model="selected.sender"
      value="grp1.rc1"
      aria-label
      type="radio"
      id="check10"
    >
    <input
      v-model="selected.sender"
      value="grp1.refn.oc"
      aria-label
      type="radio"
      id="check13"
    >
    <input
      v-model="selected.sender"
      value="grp1.refn.ic1"
      aria-label
      type="radio"
      id="check17"
    >
    <input
      v-model="selected.sender"
      value="grp1.refn.icn"
      aria-label
      type="radio"
      id="check18"
    >
    <input
      v-model="selected.sender"
      value="grp1.refn.oc_ad1"
      aria-label
      type="radio"
      id="check11"
    >
    <input
      v-model="selected.sender"
      value="grp1.refn.oc_adn"
      aria-label
      type="radio"
      id="check12"
    >
    <input
      v-model="selected.sender"
      value="grp1.refn.ic1_ad1"
      aria-label
      type="radio"
      id="check16"
    >
    <input
      v-model="selected.sender"
      value="grp1.refn.ic1_adn"
      aria-label
      type="radio"
      id="check14"
    >
    <input
      v-model="selected.sender"
      value="grp1.refn.icn_ad1"
      aria-label
      type="radio"
      id="check19"
    >
    <input
      v-model="selected.sender"
      value="grp1.refn.icn_adn"
      aria-label
      type="radio"
      id="check15"
    >
    <input
      v-model="selected.sender"
      value="grp1.rcn"
      aria-label
      type="radio"
      id="check20"
    >
    <input
      v-model="selected.sender"
      value="grpn.ref1.oc"
      aria-label
      type="radio"
      id="check23"
    >
    <input
      v-model="selected.sender"
      value="grpn.ref1.ic1"
      aria-label
      type="radio"
      id="check27"
    >
    <input
      v-model="selected.sender"
      value="grpn.ref1.icn"
      aria-label
      type="radio"
      id="check28"
    >
    <input
      v-model="selected.sender"
      value="grpn.ref1.oc_ad1"
      aria-label
      type="radio"
      id="check21"
    >
    <input
      v-model="selected.sender"
      value="grpn.ref1.oc_adn"
      aria-label
      type="radio"
      id="check22"
    >
    <input
      v-model="selected.sender"
      value="grpn.ref1.ic1_ad1"
      aria-label
      type="radio"
      id="check26"
    >
    <input
      v-model="selected.sender"
      value="grpn.ref1.ic1_adn"
      aria-label
      type="radio"
      id="check24"
    >
    <input
      v-model="selected.sender"
      value="grpn.ref1.icn_ad1"
      aria-label
      type="radio"
      id="check29"
    >
    <input
      v-model="selected.sender"
      value="grpn.ref1.icn_adn"
      aria-label
      type="radio"
      id="check25"
    >
    <input
      v-model="selected.sender"
      value="grpn.rc1"
      aria-label
      type="radio"
      id="check30"
    >
    <input
      v-model="selected.sender"
      value="grpn.refn.oc"
      aria-label
      type="radio"
      id="check33"
    >
    <input
      v-model="selected.sender"
      value="grpn.refn.ic1"
      aria-label
      type="radio"
      id="check37"
    >
    <input
      v-model="selected.sender"
      value="grpn.refn.icn"
      aria-label
      type="radio"
      id="check38"
    >
    <input
      v-model="selected.sender"
      value="grpn.refn.oc_ad1"
      aria-label
      type="radio"
      id="check31"
    >
    <input
      v-model="selected.sender"
      value="grpn.refn.oc_adn"
      aria-label
      type="radio"
      id="check32"
    >
    <input
      v-model="selected.sender"
      value="grpn.refn.ic1_ad1"
      aria-label
      type="radio"
      id="check36"
    >
    <input
      v-model="selected.sender"
      value="grpn.refn.ic1_adn"
      aria-label
      type="radio"
      id="check34"
    >
    <input
      v-model="selected.sender"
      value="grpn.refn.icn_ad1"
      aria-label
      type="radio"
      id="check39"
    >
    <input
      v-model="selected.sender"
      value="grpn.refn.icn_adn"
      aria-label
      type="radio"
      id="check35"
    >
    <input
      v-model="selected.sender"
      value="grpn.rcn"
      aria-label
      type="radio"
      id="check40"
    >
    <input
      v-model="selected.destination.grp1.ref1.oc"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check43"
    >
    <input
      v-model="selected.destination.grp1.ref1.ic1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check47"
    >
    <input
      v-model="selected.destination.grp1.ref1.icn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check48"
    >
    <input
      v-model="selected.destination.grp1.ref1.oc_ad1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check41"
    >
    <input
      v-model="selected.destination.grp1.ref1.oc_adn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check42"
    >
    <input
      v-model="selected.destination.grp1.ref1.ic1_ad1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check46"
    >
    <input
      v-model="selected.destination.grp1.ref1.ic1_adn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check44"
    >
    <input
      v-model="selected.destination.grp1.ref1.icn_ad1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check49"
    >
    <input
      v-model="selected.destination.grp1.ref1.icn_adn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check45"
    >
    <input
      v-model="selected.destination.grp1.rc1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check50"
    >
    <input
      v-model="selected.destination.grp1.refn.oc"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check53"
    >
    <input
      v-model="selected.destination.grp1.refn.ic1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check57"
    >
    <input
      v-model="selected.destination.grp1.refn.icn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check58"
    >
    <input
      v-model="selected.destination.grp1.refn.oc_ad1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check51"
    >
    <input
      v-model="selected.destination.grp1.refn.oc_adn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check52"
    >
    <input
      v-model="selected.destination.grp1.refn.ic1_ad1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check56"
    >
    <input
      v-model="selected.destination.grp1.refn.ic1_adn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check54"
    >
    <input
      v-model="selected.destination.grp1.refn.icn_ad1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check59"
    >
    <input
      v-model="selected.destination.grp1.refn.icn_adn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check55"
    >
    <input
      v-model="selected.destination.grp1.rcn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check60"
    >
    <input
      v-model="selected.destination.grpn.ref1.oc"
      aria-label
      type="checkbox"
      id="check63"
    >
    <input
      v-model="selected.destination.grpn.ref1.ic1"
      aria-label
      type="checkbox"
      id="check67"
    >
    <input
      v-model="selected.destination.grpn.ref1.icn"
      aria-label
      type="checkbox"
      id="check68"
    >
    <input
      v-model="selected.destination.grpn.ref1.oc_ad1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check61"
    >
    <input
      v-model="selected.destination.grpn.ref1.oc_adn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check62"
    >
    <input
      v-model="selected.destination.grpn.ref1.ic1_ad1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check66"
    >
    <input
      v-model="selected.destination.grpn.ref1.ic1_adn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check64"
    >
    <input
      v-model="selected.destination.grpn.ref1.icn_ad1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check69"
    >
    <input
      v-model="selected.destination.grpn.ref1.icn_adn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check65"
    >
    <input
      v-model="selected.destination.grpn.rc1"
      aria-label
      type="checkbox"
      id="check70"
    >
    <input
      v-model="selected.destination.grpn.refn.oc"
      aria-label
      type="checkbox"
      id="check73"
    >
    <input
      v-model="selected.destination.grpn.refn.ic1"
      aria-label
      type="checkbox"
      id="check77"
    >
    <input
      v-model="selected.destination.grpn.refn.icn"
      aria-label
      type="checkbox"
      id="check78"
    >
    <input
      v-model="selected.destination.grpn.refn.oc_ad1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check71"
    >
    <input
      v-model="selected.destination.grpn.refn.oc_adn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check72"
    >
    <input
      v-model="selected.destination.grpn.refn.ic1_ad1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check76"
    >
    <input
      v-model="selected.destination.grpn.refn.ic1_adn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check74"
    >
    <input
      v-model="selected.destination.grpn.refn.icn_ad1"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check79"
    >
    <input
      v-model="selected.destination.grpn.refn.icn_adn"
      :unchecked-value="false"
      aria-label
      type="checkbox"
      id="check75"
    >
    <input
      v-model="selected.destination.grpn.rcn"
      aria-label
      type="checkbox"
      id="check80"
    >
    <b-form-group>
      <input
        v-model="destination_type_selector"
        value="self_ref"
        @change="selectSelfGroup"
        type="radio"
        id="check82"
      >
      <input
        v-model="destination_type_selector"
        value="self_grp"
        @change="selectSelfRef"
        type="radio"
        id="check81"
      >
      <input
        v-model="destination_type_selector"
        value="self_ref_and_self_rc"
        @change="selectSelfMA"
        type="radio"
        id="check83"
      >
      <b-button @click="removeSelecter" pill small variant="outline-secondary">宛先選択解除</b-button>
    </b-form-group>
    <p>送信元: {{ $data.definedSender }}</p>
    <p>送信先: {{ $data.definedDestination.join(' + ') }}</p>
    <p>登録: {{ Object.keys($data.validatedAddress).length === 0 ? '登録なし' : '登録済み'}}</p>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
export default {
  name: 'AddressSelect',
  data () {
    return {
      destination_type_selector: '',
      selected_destination: [],
      definedSender: '',
      definedDestination: [],
      targetSelectedDestination: {},
      registeredComPathList: [],
      validatedAddress: {},
      selected: {
        sender: '',
        destination: {
          grp1: {
            ref1: {
              oc: false,
              ic1: false,
              icn: false,
              oc_ad1: false,
              oc_adn: false,
              ic1_ad1: false,
              ic1_adn: false,
              icn_ad1: false,
              icn_adn: false,
              ics: false,
              oc_ads: false,
              ic1_ads: false,
              icn_ads: false,
              ics_ads: false,
              all: false
            },
            rc1: false,
            refn: {
              oc: false,
              ic1: false,
              icn: false,
              oc_ad1: false,
              oc_adn: false,
              ic1_ad1: false,
              ic1_adn: false,
              icn_ad1: false,
              icn_adn: false,
              ics: false,
              oc_ads: false,
              ic1_ads: false,
              icn_ads: false,
              ics_ads: false,
              all: false
            },
            rcn: false,
            rcs: false,
            refs_ic1: false,
            refs_ocs: false,
            refs_oc_ads: false,
            refs_ics: false,
            refs_ic1_ads: false,
            refs_icn_ads: false,
            refs_ics_ads: false,
            refs_all: false
          },
          grpn: {
            ref1: {
              oc: false,
              ic1: false,
              icn: false,
              oc_ad1: false,
              oc_adn: false,
              ic1_ad1: false,
              ic1_adn: false,
              icn_ad1: false,
              icn_adn: false,
              ics: false,
              oc_ads: false,
              ic1_ads: false,
              icn_ads: false,
              ics_ads: false,
              all: false
            },
            rc1: false,
            refn: {
              oc: false,
              ic1: false,
              icn: false,
              oc_ad1: false,
              oc_adn: false,
              ic1_ad1: false,
              ic1_adn: false,
              icn_ad1: false,
              icn_adn: false,
              ics: false,
              oc_ads: false,
              ic1_ads: false,
              icn_ads: false,
              ics_ads: false,
              all: false
            },
            rcn: false,
            rcs: false,
            refs_ic1: false,
            refs_ocs: false,
            refs_oc_ads: false,
            refs_ics: false,
            refs_ic1_ads: false,
            refs_icn_ads: false,
            refs_ics_ads: false,
            refs_all: false
          }
        }
      }
    }
  },
  async created () {
    const ComPath = await API.graphql(graphqlOperation(`
      query listCommunicationPath {
        listCommunicationPathMaster{
          items {
            design_sender
            design_destination
            communication_path_list{
              sa
              sr
              da
              dr
              protocol
            }
          }
        }
      }
    `))
    this.$log.debug('======Communication Path======', ComPath.data.listCommunicationPathMaster)
    this.registeredComPathList = ComPath.data.listCommunicationPathMaster.items
  },
  methods: {
    objectLevelJudge () {
      const targetRefs = [
        this.targetSelectedDestination.grp1.ref1,
        this.targetSelectedDestination.grp1.refn,
        this.targetSelectedDestination.grpn.ref1,
        this.targetSelectedDestination.grpn.refn
      ]
      targetRefs.forEach(function (ref) {
        // oc_ads判定
        if (ref.oc_ad1 && ref.oc_adn) {
          if (typeof ref.oc_ads !== 'undefined') {
            ref.oc_ads = true
          } else {
            ref.oc_ads = true
          }
          ref.oc_ad1 = false
          ref.oc_adn = false
        }
        // ic1_ads判定
        if (ref.ic1_ad1 && ref.ic1_adn) {
          if (typeof ref.ic1_ads !== 'undefined') {
            ref.ic1_ads = true
          } else {
            ref.ic1_ads = true
          }
          ref.ic1_ad1 = false
          ref.ic1_adn = false
        }
        // icn_ads判定
        if (ref.icn_ad1 && ref.icn_adn) {
          if (typeof ref.icn_ads !== 'undefined') {
            ref.icn_ads = true
          } else {
            ref.icn_ads = true
          }
          ref.icn_ad1 = false
          ref.icn_adn = false
        }
        // ics判定
        if (ref.ic1 && ref.icn) {
          if (typeof ref.ics !== 'undefined') {
            ref.ics = true
          } else {
            ref.ics = true
          }
          ref.ic1 = false
          ref.icn = false
        }
        // ics_ads判定
        if (ref.ic1_ads && ref.icn_ads) {
          ref.ics_ads = true
          ref.ic1_ads = false
          ref.icn_ads = false
        }
        // ics_ads判定
        if (ref.ic1_ads && ref.icn_ads) {
          ref.ics_ads = true
          ref.ic1_ads = false
          ref.icn_ads = false
        }
        // all判定
        if (ref.oc && ref.oc_ads && ref.ics_ads && ref.ics) {
          ref.all = true
          ref.oc = false
          ref.oc_ads = false
          ref.ics_ads = false
          ref.ics = false
        }
      })
    },
    refLevelJudge () {
      const targetGroups = [
        this.targetSelectedDestination.grp1,
        this.targetSelectedDestination.grpn
      ]
      targetGroups.forEach(function (grp) {
        // grp_refs_ic1判定
        if (grp.ref1.ic1 && grp.refn.ic1) {
          if (typeof grp.refs_ic1 !== 'undefined') {
            grp.refs_ic1 = true
          } else {
            grp.refs_ic1 = true
          }
          grp.ref1.ic1 = false
          grp.refn.ic1 = false
        }
        // grp_refs_oc_ads判定
        if (grp.ref1.oc_ads && grp.refn.oc_ads) {
          if (typeof grp.refs_oc_ads !== 'undefined') {
            grp.refs_oc_ads = true
          } else {
            grp.refs_oc_ads = true
          }
          grp.ref1.oc_ads = false
          grp.refn.oc_ads = false
        }
        // grp_refs_ic1_ads判定
        if (grp.ref1.ic1_ads && grp.refn.ic1_ads) {
          if (typeof grp.refs_ic1_ads !== 'undefined') {
            grp.refs_ic1_ads = true
          } else {
            grp.refs_ic1_ads = true
          }
          grp.ref1.ic1_ads = false
          grp.refn.ic1_ads = false
        }
        // grp_refs_icn_ads判定
        if (grp.ref1.icn_ads && grp.refn.icn_ads) {
          if (typeof grp.refs_icn_ads !== 'undefined') {
            grp.refs_icn_ads = true
          } else {
            grp.refs_icn_ads = true
          }
          grp.ref1.icn_ads = false
          grp.refn.icn_ads = false
        }
        // grp_refs_ics_ads判定
        if (grp.ref1.ics_ads && grp.refn.ics_ads) {
          if (typeof grp.refs_ics_ads !== 'undefined') {
            grp.refs_ics_ads = true
          } else {
            grp.refs_ics_ads = true
          }
          grp.ref1.ics_ads = false
          grp.refn.ics_ads = false
        }
        // grp_refs_ics判定
        if (grp.ref1.ics && grp.refn.ics) {
          if (typeof grp.refs_ics !== 'undefined') {
            grp.refs_ics = true
          } else {
            grp.refs_ics = true
          }
          grp.ref1.ics = false
          grp.refn.ics = false
        }
        // grp_refs_ocs判定
        if (grp.ref1.oc && grp.refn.oc) {
          if (typeof grp.refs_ocs !== 'undefined') {
            grp.refs_ocs = true
          } else {
            grp.refs_ocs = true
          }
          grp.ref1.oc = false
          grp.refn.oc = false
        }
        // rcs判定
        if (grp.rc1 && grp.rcn) {
          grp.rcs = true
          grp.rc1 = false
          grp.rcn = false
        }
        // grp_refs_all判定
        if (grp.ref1.all && grp.refn.all && grp.rcs) {
          if (typeof grp.refs_all !== 'undefined') {
            grp.refs_all = true
          } else {
            grp.refs_all = true
          }
          grp.ref1.all = false
          grp.refn.all = false
          grp.rcs = false
        }
      })
    },
    translateName (target) {
      const removeUnderscore = target.split('_').join('.')
      const removeAll = removeUnderscore.replace(/.all$/, '')
      const modifyGrpRefs = removeAll.replace(/^grp1.refs$/, 'grp1').replace(/^grpn.refs$/, 'grpn')
      return modifyGrpRefs.replace(/^grp/, 'Grp').replace(/.ref/, '.Ref').replace(/.ic/, '.IC').replace(/.oc/, '.OC').replace(/.ad/, '.AD').replace(/.rc/, '.RC')
    },
    integrateJudge () {
      const targets = []
      const selected = this.targetSelectedDestination
      for (const grp in selected) {
        for (const ref in selected[grp]) {
          for (const obj in selected[grp][ref]) {
            if (selected[grp][ref][obj] && typeof selected[grp][ref][obj] === 'boolean') {
              targets.push(`${grp}.${ref}.${obj}`)
            }
          }
          if (selected[grp][ref] && typeof selected[grp][ref] === 'boolean') {
            targets.push(`${grp}.${ref}`)
          }
        }
        if (selected[grp] && typeof selected[grp] === 'boolean') {
          targets.push(`${grp}`)
        }
      }
      this.definedDestination = targets.map(function (elm) {
        return this.translateName(elm)
      }.bind(this))
      this.$log.debug(this.definedDestination)
    },
    allLevelJudge () {
      this.targetSelectedDestination = JSON.parse(JSON.stringify(this.selected.destination))
      this.objectLevelJudge()
      this.refLevelJudge()
      this.integrateJudge()
    },
    resetAll () {
      const destination = this.selected.destination
      for (const grp in destination) {
        for (const ref in destination[grp]) {
          for (const obj in destination[grp][ref]) {
            if (typeof destination[grp][ref][obj] === 'boolean') {
              destination[grp][ref][obj] = false
            }
          }
          if (typeof destination[grp][ref] === 'boolean') {
            destination[grp][ref] = false
          }
        }
        if (typeof destination[grp] === 'boolean') {
          destination[grp] = false
        }
      }
    },
    selectSelfRef () {
      if (this.selected.sender === '') {
        this.$log.debug('======sender not selected======')
        return
      }
      this.resetAll()
      const senderGroupName = this.selected.sender.split('.')[0]
      const senderRefName = this.selected.sender.split('.')[1]
      const senderRef = this.selected.destination[senderGroupName][senderRefName]
      for (const obj in senderRef) {
        if (obj === 'oc' ||
            obj === 'ic1' ||
            obj === 'icn' ||
            obj === 'oc_ad1' ||
            obj === 'oc_adn' ||
            obj === 'ic1_ad1' ||
            obj === 'ic1_adn' ||
            obj === 'icn_ad1' ||
            obj === 'icn_adn'
        ) {
          senderRef[obj] = true
        }
      }
    },
    selectSelfMA () {
      if (this.selected.sender === '') {
        this.$log.debug('======sender not selected======')
        return
      }
      this.resetAll()
      const senderGroupName = this.selected.sender.split('.')[0]
      const senderGroup = this.selected.destination[senderGroupName]
      senderGroup.rc1 = true
      senderGroup.rcn = true
      senderGroup.ref1.ic1 = true
      senderGroup.refn.ic1 = true
    },
    selectSelfGroup () {
      if (this.selected.sender === '') {
        this.$log.debug('======sender not selected======')
        return
      }
      this.resetAll()
      const senderGroupName = this.selected.sender.split('.')[0]
      const senderGroup = this.selected.destination[senderGroupName]
      for (const ref in senderGroup) {
        for (const obj in senderGroup[ref]) {
          if (obj === 'oc' ||
              obj === 'ic1' ||
              obj === 'icn' ||
              obj === 'oc_ad1' ||
              obj === 'oc_adn' ||
              obj === 'ic1_ad1' ||
              obj === 'ic1_adn' ||
              obj === 'icn_ad1' ||
              obj === 'icn_adn'
          ) {
            senderGroup[ref][obj] = true
          }
        }
      }
      senderGroup.rc1 = true
      senderGroup.rcn = true
    },
    removeSelecter () {
      this.destination_type_selector = ''
      this.resetAll()
    },
    searchComPathList () {
      this.$emit('registerPath', {})
      if (this.definedDestination.length > 2 || this.definedDestination.length === 0 || this.definedSender === '') {
        this.validatedAddress = {}
        return
      }
      const dumpedDestination = this.definedDestination.join('+')
      const tempReversed = this.definedDestination.reverse()
      const dumpedDestinationReversed = tempReversed.join('+')
      const matchedComPath = this.registeredComPathList.find(function (elm) {
        const isSenderValid = elm.design_sender === this.definedSender
        const isDestinationValid = elm.design_destination === dumpedDestination || elm.design_destination === dumpedDestinationReversed
        return isSenderValid && isDestinationValid
      }.bind(this))
      if (typeof matchedComPath !== 'undefined') {
        this.validatedAddress = matchedComPath
        this.$emit('registerPath', this.validatedAddress)
      } else {
        this.validatedAddress = {}
        this.$emit('registerPath', this.validatedAddress)
      }
    }
  },
  watch: {
    'selected.sender': function (newValue) {
      this.definedSender = this.translateName(newValue)
      this.removeSelecter()
    },
    'selected.destination': {
      handler: function () {
        this.allLevelJudge()
        this.searchComPathList()
      },
      deep: true
    }
  }
}
</script>
<style>
#base_image {
  width: 1500px;
  position: relative;
}

#base_image img {
  width: 100%;
  z-index: -1;
}

#check1 {
  position: absolute;
  top: 61px;
  left: 178px;
}

#check2 {
  position: absolute;
  top: 61px;
  left: 266px;
}

#check3 {
  position: absolute;
  top: 125px;
  left: 177px;
}

#check4 {
  position: absolute;
  top: 175px;
  left: 101px;
}

#check5 {
  position: absolute;
  top: 174px;
  left: 339px;
}

#check6 {
  position: absolute;
  top: 234px;
  left: 101px;
}

#check7 {
  position: absolute;
  top: 234px;
  left: 177px;
}

#check8 {
  position: absolute;
  top: 235px;
  left: 264px;
}

#check9 {
  position: absolute;
  top: 235px;
  left: 340px;
}

#check10 {
  position: absolute;
  top: 329px;
  left: 177px;
}

#check11 {
  position: absolute;
  top: 61px;
  left: 513px;
}

#check12 {
  position: absolute;
  top: 61px;
  left: 602px;
}

#check13 {
  position: absolute;
  top: 125px;
  left: 513px;
}

#check14 {
  position: absolute;
  top: 175px;
  left: 437px;
}

#check15 {
  position: absolute;
  top: 174px;
  left: 675px;
}

#check16 {
  position: absolute;
  top: 234px;
  left: 437px;
}

#check17 {
  position: absolute;
  top: 235px;
  left: 512px;
}

#check18 {
  position: absolute;
  top: 235px;
  left: 600px;
}

#check19 {
  position: absolute;
  top: 236px;
  left: 676px;
}

#check20 {
  position: absolute;
  top: 329px;
  left: 513px;
}

#check21 {
  position: absolute;
  top: 61px;
  left: 878px;
}

#check22 {
  position: absolute;
  top: 61px;
  left: 967px;
}

#check23 {
  position: absolute;
  top: 125px;
  left: 878px;
}

#check24 {
  position: absolute;
  top: 175px;
  left: 802px;
}

#check25 {
  position: absolute;
  top: 174px;
  left: 1040px;
}

#check26 {
  position: absolute;
  top: 234px;
  left: 802px;
}

#check27 {
  position: absolute;
  top: 235px;
  left: 877px;
}

#check28 {
  position: absolute;
  top: 235px;
  left: 965px;
}

#check29 {
  position: absolute;
  top: 236px;
  left: 1041px;
}

#check30 {
  position: absolute;
  top: 329px;
  left: 878px;
}

#check31 {
  position: absolute;
  top: 61px;
  left: 1214px;
}

#check32 {
  position: absolute;
  top: 61px;
  left: 1303px;
}

#check33 {
  position: absolute;
  top: 125px;
  left: 1214px;
}

#check34 {
  position: absolute;
  top: 175px;
  left: 1138px;
}

#check35 {
  position: absolute;
  top: 174px;
  left: 1376px;
}

#check36 {
  position: absolute;
  top: 234px;
  left: 1138px;
}

#check37 {
  position: absolute;
  top: 235px;
  left: 1213px;
}

#check38 {
  position: absolute;
  top: 235px;
  left: 1301px;
}

#check39 {
  position: absolute;
  top: 236px;
  left: 1377px;
}

#check40 {
  position: absolute;
  top: 329px;
  left: 1214px;
}

#check41 {
  position: absolute;
  top: 461px;
  left: 178px;
}

#check42 {
  position: absolute;
  top: 461px;
  left: 266px;
}

#check43 {
  position: absolute;
  top: 525px;
  left: 177px;
}

#check44 {
  position: absolute;
  top: 575px;
  left: 101px;
}

#check45 {
  position: absolute;
  top: 574px;
  left: 339px;
}

#check46 {
  position: absolute;
  top: 634px;
  left: 101px;
}

#check47 {
  position: absolute;
  top: 634px;
  left: 177px;
}

#check48 {
  position: absolute;
  top: 635px;
  left: 264px;
}

#check49 {
  position: absolute;
  top: 635px;
  left: 340px;
}

#check50 {
  position: absolute;
  top: 729px;
  left: 177px;
}

#check51 {
  position: absolute;
  top: 461px;
  left: 513px;
}

#check52 {
  position: absolute;
  top: 461px;
  left: 602px;
}

#check53 {
  position: absolute;
  top: 525px;
  left: 513px;
}

#check54 {
  position: absolute;
  top: 575px;
  left: 437px;
}

#check55 {
  position: absolute;
  top: 574px;
  left: 675px;
}

#check56 {
  position: absolute;
  top: 634px;
  left: 437px;
}

#check57 {
  position: absolute;
  top: 635px;
  left: 512px;
}

#check58 {
  position: absolute;
  top: 635px;
  left: 600px;
}

#check59 {
  position: absolute;
  top: 636px;
  left: 676px;
}

#check60 {
  position: absolute;
  top: 729px;
  left: 513px;
}

#check61 {
  position: absolute;
  top: 461px;
  left: 878px;
}

#check62 {
  position: absolute;
  top: 461px;
  left: 967px;
}

#check63 {
  position: absolute;
  top: 525px;
  left: 878px;
}

#check64 {
  position: absolute;
  top: 575px;
  left: 802px;
}

#check65 {
  position: absolute;
  top: 574px;
  left: 1040px;
}

#check66 {
  position: absolute;
  top: 634px;
  left: 802px;
}

#check67 {
  position: absolute;
  top: 635px;
  left: 877px;
}

#check68 {
  position: absolute;
  top: 635px;
  left: 965px;
}

#check69 {
  position: absolute;
  top: 636px;
  left: 1041px;
}

#check70 {
  position: absolute;
  top: 729px;
  left: 878px;
}

#check71 {
  position: absolute;
  top: 461px;
  left: 1214px;
}

#check72 {
  position: absolute;
  top: 461px;
  left: 1303px;
}

#check73 {
  position: absolute;
  top: 525px;
  left: 1214px;
}

#check74 {
  position: absolute;
  top: 575px;
  left: 1138px;
}

#check75 {
  position: absolute;
  top: 574px;
  left: 1376px;
}

#check76 {
  position: absolute;
  top: 634px;
  left: 1138px;
}

#check77 {
  position: absolute;
  top: 635px;
  left: 1213px;
}

#check78 {
  position: absolute;
  top: 635px;
  left: 1301px;
}

#check79 {
  position: absolute;
  top: 636px;
  left: 1377px;
}

#check80 {
  position: absolute;
  top: 729px;
  left: 1214px;
}

#check81 {
  position: absolute;
  top: 711px;
  left: 10px;
}

#check82 {
  position: absolute;
  top: 735px;
  left: 10px;
}

#check83 {
  position: absolute;
  top: 760px;
  left: 10px;
}

</style>
